module.exports = __webpack_public_path__ + "static/img/展示2.01271fbc.png";